function Main_CoverImage() {
  return <img
  src="assets/Somna/Logo_PureKoorSomna.webp"
  srcSet="assets/Somna/Logo_PureKoorSomnaLQ.webp 1028w, assets/Somna/Logo_PureKoorSomna.webp 4110w"
  sizes="(min-width: 1280px) 1280px, 100vw"
  width="4110"
  height="1275"
  fetchpriority="high"
  alt="Header Image PureKoor Art and Video with Sleepy Koor"
  className="max-w-7xl w-full mx-auto h-auto"
/>
}

export default Main_CoverImage;
